import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { color, themeType, typo } from '../../styles/style';
import FormAtom from '../atoms/FormAtom';
import ImgAtom from '../atoms/ImgAtom';
import InformAtom from '../atoms/InformAtom';
import LineAtom from '../atoms/LineAtom';
import TextAtom from '../atoms/TextAtom';

const ContactOuter = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 170px;
  ${({ theme }) => theme.media.mobile`
  margin-bottom: 0px;
    `}
`;
const ContactBg = styled.div`
  display: flex;
  width: 80%;
  height: 603px;
  margin-top: 26px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
  border-radius: 20px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #efefef;
    z-index: -1;
    filter: blur(55px);
    -webkit-filter: blur(55px);
    -moz-filter: blur(55px);
    -o-filter: blur(55px);
    -ms-filter: blur(55px);
  }

  ${({ theme }) => theme.media.tablet`
  width: 100%;
    `}
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  height: auto;
    `}
`;
const ContactBox = styled.div`
display: flex;
width: 100%;
height: 603px;
justify-content: space-between;
flex-wrap: wrap;
  ${({ theme }) => theme.media.tablet`
  width: 100%;
    `}
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  flex-direction: column;
  height: auto;
    `}
`
const Contactleft = styled.div`
  display: flex;
  width: 65%;
  flex-wrap: wrap;
  flex-direction: column;
  border-radius: 20px;
  background: #fff;
  ${({ theme }) => theme.media.tablet`
  width: 62%;
  border-radius: 0px;
    `}
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  border: 0px;
  border-radius: 0px;
    `}
`;
const Contactright = styled.div`
  display: flex;
  width: 32%;
  border-radius: 20px;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: column;
  background: #fff;
  padding-left: 33px;
  ${({ theme }) => theme.media.tablet`
  width: 38%;
  min-width: 0;
  border-radius: 0px;
    `}
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  border: 0px;
  min-width: 0;
  padding:0px;
  align-items: flex-start;
  border-radius: 0px;
  padding: 0 10% 0 10%;
    `}
`;


class ContactMolecule extends PureComponent {
    constructor(props){
        super(props)

        this.state ={

        }
    }
    render() {
        return (
          <ContactOuter>
            <ContactBg>
              <ContactBox>
                <Contactleft>
                  <TextAtom
                    height="40px"
                    margin="82px 0 13px 0"
                    padding=" 0 0 0 10%"
                    justifyContent="flex-start"
                    text="문의 메세지 보내기"
                    typo={typo.subTitle.s1}
                    color={color(themeType.dark).text.primary}
                  />
                  <LineAtom />
                  <FormAtom />
                </Contactleft>
                <Contactright>
                  <TextAtom
                    height="40px"
                    margin="82px 0 13px 0"
                    justifyContent="flex-start"
                    text="회사 정보"
                    typo={typo.subTitle.s1}
                    color={color(themeType.dark).text.primary}
                  />
                  <LineAtom
                  paddingLeft="0" />
                  <InformAtom />
                  <ImgAtom
                    src="../images/lab254_logo2.png"
                    height="17%"
                    margin ="18px auto 0px"
                    padding="0 33px 0 0"
                    width="auto"
                    displayM="display:none"
                  />
                </Contactright>
              </ContactBox>
            </ContactBg>
          </ContactOuter>
           
        );
    }
}

export default ContactMolecule;